export * from './ubicacion-list/ubicacion-list.component';
export * from './ubicacion-create/ubicacion-create.component';
export * from './ubicacion-edit/ubicacion-edit.component';
export * from './ubicacion-detail/ubicacion-detail.component';
